var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChevronUpPink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 11.4 7.1",
    overflow: "visible",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HAN-iconen-rood_cmyk-Chevron",
    transform: "translate(82.414 115.56)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "outline",
    transform: "translate(-88.707 -100.146) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    fill: "#E50056",
    d: "M9.7,17.7l-1.4-1.4l4.3-4.3L8.3,7.7l1.4-1.4l5.7,5.7L9.7,17.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronUpPink);
export default __webpack_public_path__ + "static/media/icon_chevron_up_pink.ad457a7b7f11516558a45bf92afccce8.svg";
export { ForwardRef as ReactComponent };